import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

// top: -29px;
const SvgCircle = styled('svg')`
  position: absolute;
  height: 16px;
  width: 16px;
  margin: 0;
  z-index: 1;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);
`;

export class Circle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <SvgCircle viewBox="0 0 16 16" {...this.props}>
        <g transform="translate(-994.000000, -4420.000000)">
          <g transform="translate(160.000000, 4051.000000)">
            <g transform="translate(834.000000, 369.000000)">
              <circle cx="8" cy="8" r="8" fill={'#DB3737'} />
              <path
                d="M7.9997855,7.19182883 L4.80795667,4 L4,4.80795667 L7.19125743,7.9997855 L4,11.1916143 L4.80795667,11.999571 L7.9997855,8.80774217 L11.1916143,11.999571 L11.9989996,11.1916143 L8.80774217,7.9997855 L11.9989996,4.80795667 L11.1916143,4 L7.9997855,7.19182883 Z"
                stroke="#FFFFFF"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
      </SvgCircle>
    );
  }
}
